'use strict';

frontendApp.factory('IntroService', ['$rootScope', '$log', '$window', '$location', 'HttpService', function ($rootScope, $log, $window, $location, HttpService) {

  var _service = {};

  var projectPageSteps = [
    {
      element: '#accountNavigation',
      intro: "This is where you go to change your settings, get help from support, or log out.",
      position: 'bottom'
    },
    {
      element: '#mainBadge',
      intro: "This is your profile picture. Simply click to change it.",
      position: 'right'
    },
    {
      element: '#mainNavigation',
      intro: "This is the main navigation.  You can always get back to the main project page, or Quick Loader whenever you need to.",
      position: 'right'
    },

    {
      element: '#projectTabs ul.nav-tabs li[heading="Favorites"]',
      intro: "This tab shows you your favorite projects. Click the \"star\" next to a project name to make it a favorite.",
      position: 'top'
    },
    {
      element: '#projectTabs ul.nav-tabs li[heading="My Projects"]',
      intro: "The \"My Projects\" tab holds your complete project list",
      position: 'top'
    },
    {
      element: '#myProjectsTable',
      intro: "We created a project for you when you first signed up, clicking it's name will take you to the Project Detail page.  From there you'll be able to add data to your project.",
      position: 'top',
      doneLabel: 'Go to project page'
    }
  ];

  var intro = null;

  _service.startProjectPageIntro = function (projects) {
    if (intro) intro.exit();
    intro = introJs();
    intro.setOptions({steps: projectPageSteps});

    intro.onbeforechange(function (targetElement) {
      $rootScope.$broadcast('IntroService.currentStepChanged', this._currentStep);
    });

    intro.oncomplete(function () {
      $rootScope.$apply(function () {
        $location.path('/project/' + _.first(projects).id).search({'intro': 'true'});
      });
    });

    intro.start();
  };

  var projectDetailPageSteps = [
    {
      element: '#projectDetailProjectName',
      intro: "Here is the name of your project",
      position: 'bottom'
    },
    {
      element: '#projectDetailAddMoreData',
      intro: "Easily add some data to this project",
      position: 'bottom'
    },
    {
      element: '#projectDetailBreadcrumb',
      intro: "This breadcrumb allows you to quickly navigate backwards",
      position: 'top'
    }
  ];

  _service.startProjectDetailIntro = function () {
    if (intro) intro.exit();
    intro = introJs();
    intro.setOptions({steps: projectDetailPageSteps});

    intro.onbeforechange(function (targetElement) {
      $rootScope.$broadcast('IntroService.currentStepChanged', this._currentStep);
    });

    intro.start();
  };

  return _service;

}]);
